/* eslint max-len: 0 */
export const DEFAULT_METADATA = {
  title: 'Ocado, the online supermarket',
  titleSuffix: ' | Ocado',
  meta: [
    {
      name: 'description',
      content: 'Browse and shop from Ocado. Find your favourite groceries, household essentials, and value delivered at Ocado.',
    },
    {
      name: 'keywords',
      content: 'online supermarket, supermarket, groceries online, online groceries, supermarket uk, online shop, London, England, customer service, shopping online, good food, food shopping, online shopping, online delivery, organic, same day delivery, special offers, sale, groceries to your door, family shopping, recipes, family, kids, free food delivery, free delivery service, grocery shopping, online grocery shop, grocery delivery, delivered to your door, home shopping, home delivery, wine, wine cellar, wine shop, wine delivery, wine online, fresh food, order online, check postcode, organic food, gift hampers, food hampers, ocado van, award-winning groceries, flowers, bouquets, flower delivery, flowers online, flower shop, home furnishings, toys, garden, gardening, beauty, make-up, holiday shop, gifts, gifts online, gift delivery, vegetarian, free-from, gluten-free, wheat-free, own brand, own-label, waitrose, waitrose.com, waitrose direct, waitrose wine, low prices, Brand Match, Price Match, Waitrose Brand Price Match, Waitrose price match, John Lewis',
    },
  ],
};

export default {
  retailer: 'Ocado',
  metaData: {
    getCatalogueDescription: (productGroup) => `Browse and shop ${productGroup} from Ocado. Find your favourite groceries, household essentials, and value delivered at Ocado.`,
    defaultRegularsDescription: 'Save time with every shop. Order something regularly? Make it an Ocado Regular and it will be added to your trolley on Mondays' +
      ' as often as you choose.',
  },
  textkey: 'Text value ocado',
  admin: {
    header: {
      logoAlt: 'Ocado - Home',
    },
  },
  common: {
    msg: {
      outOfStock: 'Out of stock',
    },
    weUseCookies: {
      msg: 'We use cookies to give you the best experience with Ocado. Continue shopping if you’re happy, or find out how to',
      linkLabel: 'manage your cookies',
      linkHref: 'https://www.ocado.com/webshop/scontent/privacyPolicy',
    },
  },
  delivery: {
    bookChristmasBtn: {
      title: 'Book your Christmas delivery',
      text: null,
    },
  },
  page: {
    title: DEFAULT_METADATA.title,
    titlePrefix: '',
    titleSuffix: DEFAULT_METADATA.titleSuffix,
    longTitle: DEFAULT_METADATA.title,
    offersTitleSuffix: DEFAULT_METADATA.titleSuffix,
    offerDetailsPrefix: '',
  },
  product: {
    alternatives: {
      seeAlternativesLabel: 'See alternatives',
    },
    ageRestriction: {
      tooltipLinkHref: '/webshop/scontent/purchasetermsandconditions#tac1',
      termsLinkLabel: 'Find out more.',
      tooltipText: 'This is an age restricted product. You’ll be asked at checkout to verify that you are over the age of 18, and our driver may request to see ID. ',
    },
    disclaimer: {
      life: 'Minimum life based on \'use-by\' date of product. Average life based on last week\'s deliveries. Life guarantee shown based on' +
        ' delivery tomorrow with the Life guarantee starting the following day.',
      lifeNoSlot: 'Please book a slot to view Life guarantee for your chosen delivery day.',
      termsAndConditions: {
        see: 'See',
        href: '/webshop/scontent/ocadoProductLife',
        linkLabel: 'Terms & Conditions',
        furtherDetails: ' for further details.',
      },
      catchWeight: 'Where fresh meat, poultry, fish, cheese, fruit or vegetables are sold by kilogram to your order, a price is stated for guidance only.' +
        ' The actual price charged will be the price applicable at the time we pick your order.',
      regularMessage: 'This page serves as a summary for information purposes only, and are designed to enhance your\n' +
        '            shopping experience on the Ocado website. While we have taken care in preparing this summary and believe it is accurate, it is not a substitute\n' +
        '            for your reading the product packaging and label prior to use. You should note that products and their ingredients are subject to change. If you\n' +
        '            do require precise ingredient information you should consult the manufacturer, whose contact details will appear on the packaging or label. Ocado\n' +
        '            is therefore unable to accept liability for any incorrect information. Where this description contains a link to another party\'s website for\n' +
        '            further information on the product, please note that Ocado has no control over and no liability for the contents of that website. You should also\n' +
        '            note that the picture images show only our serving suggestions of how to prepare your food - all table accessories and additional items and/or\n' +
        '            ingredients pictured with the product you are purchasing are not included. This data is supplied for personal use only. It may not be reproduced\n' +
        '            in any way whatsoever without Ocado Limited\'s prior consent, nor without due acknowledgement.',
    },
    lppLink: '/content/low-price-promise-60463',
    valueDeliveredLink: 'https://www.ocado.com/content/ocado-price-promise-227302',
    bopDescription: 'Find your favourite groceries, household essentials, and value delivered at Ocado.',
    bopStandardKeywords: 'online supermarket, online groceries, grocery shopping, supermarket uk, online delivery',
    oppLabel: 'Ocado Price Promise',
    smartPass: {
      icon: 'smart-pass',
      more: 'Save\u00A0even\u00A0more',
    },
  },
  fop: {
    hiddenH1: 'Ocado Offers',
    ribbon: {
      advert: 'Inspiration',
      featured: 'Featured',
      featuredAlt: 'Inspiration', // used to set the ribbon for customFopSection
      on_offer: 'On Offer & Value',
    },
    label: {
      offer: 'Offer',
      edlp: 'Value',
    },
    addButton: {
      addToTrolleyLabel: 'Add to trolley',
    },
    alternatives: {
      seeAlternativesLabel: 'See Alternatives',
    },
    offer: {
      edlp: 'Great Value',
    },
  },
  oneclick: {
    responsive: {
      fopButtonLabel: 'one click',
    },
  },
  footers: {
    footer: {
      callUs: 'Call Us',
      callUsText: '5:30am - midnight, 7 days a week, on 0345 656 1234',
      contactUs: 'Contact Us',
      emailUsTextPrefix: 'Email us',
      emailUsLink: 'mailto:ocado@ocado.com',
      emailUsText: 'ocado@ocado.com',
      careers: 'Careers',
      careersLink: '/careers',
      customerService: 'Customer Services',
      customerServiceLink: '/webshop/getAlternateContactUs.do',
      groupLinkText: 'Corporate',
      groupLink: 'http://www.ocadogroup.com',
      appsLinkText: 'Download our Apps',
      blogAltText: 'Ocado blog',
      productRequestText: "If we don't stock what you are looking for, try sending us a",
      productRequestLink: 'product request',
      copyright: 'All rights reserved. Ocado Retail Ltd',
      groupCorporate: 'Corporate',
      groupCorporateLink: 'http://www.ocadogroup.com',
      careersCorporate: 'Careers',
      careersCorporateLink: '/careers',
      sitemapCorporate: 'Sitemap',
      sitemapCorporateLink: '/webshop/displaySiteMap.do',
      termsCorporate: 'Terms of Use',
      termsCorporateLink: '/webshop/scontent/termsOfUse',
      cookie: 'New Cookie policy',
    },

  },
  ordersReserved: {
    name: 'Ocado Reserved',
    header: 'Ocado Reserved',
    termsUrl: '/webshop/scontent/ocadoReservedTerms',
    faqUrl: 'https://help.ocado.com/hc/en-us/sections/360002503411-Ocado-Reserved-',
    conflictingOrders: 'These orders will remain and will not be replaced with Ocado Reserved deliveries.',
    conflictingOrder: 'This order will remain and will not be replaced with an Ocado Reserved delivery.',
    choosePaymentMethodHeader: 'This will be used to pay for your shopping. Ocado Reserved is a free service.',
    chooseAddressHeader: 'We\'ll use this address for every Ocado Reserved order.',
    mobileNumberError: 'You must enter a mobile number to use Ocado Reserved.',
    ordersPanelHeader: 'Ocado Reserved Orders',
    noUpcomingOrders: 'Your first available Ocado Reserved slot will be in thirty days\' time: you may not see something here right now',
    payment: {
      managePaymentsButtonLabel: 'Manage payment methods',
    },
    membership: {
      activeInfo: 'Resume, cancel or suspend your Ocado Reserved delivery time',
      onHoldInfo: 'You won\'t receive any Ocado Reserved Deliveries until you resume',
      failedPaymentInfo: 'You have failed payment',
      onHoldButtonLabel: 'Pause Ocado Reserved',
      resumeButtonLabel: 'Resume',
      cancelLinkLabel: 'Cancel Ocado Reserved',
    },
    suggestedOrder: {
      ribbonDisplayName: 'Suggested Order',
    },
    chooseDay: {
      withRestrictionsLabel: 'Select a day to see available time slots.',
      withoutRestrictionsLabel: 'Select a day to see available time slots.',
    },
  },
  shoppingLists: {
    newListFormHeader: 'Name your list',
  },
  nav: {
    labels: {
      allOffers: 'All Offers',
      bannersTitle: 'Inspiration & Brands',
      browseShop: 'Aisles',
      bundleOffers: 'Bundle Offers',
      comboDeals: 'Combo deals',
      contactDetails: 'Account details',
      coupons: 'Ocado Coupons',
      deliveryAddresses: 'Delivery addresses',
      favourites: 'Favourites',
      inspiration: 'Inspiration & Offers',
      instantShop: 'Instant Shop',
      mealDeals: 'Meal Deals',
      ordersReserved: 'Ocado Reserved',
      regulars: 'Regulars',
      shoppingLists: 'Shopping Lists',
      smartPass: 'Smart Pass',
      pricePromise: 'Ocado Price Promise',
      ysh: 'Your Savings Hub',
    },
    mainMobile: {
      sectionFromScribeTitle: 'Help & Support',
    },
    urls: {
      pricePromise: '/content/ocado-price-promise-227302',
    },
  },
  search: {
    placeholder: 'Find a product',
    prominentPlaceholder: 'Search',
    recipePlaceholder: 'Find a recipe',
    submitBtn: '',
  },
  other: {
    tab: {
      myShop: 'My Ocado',
    },
  },
  breadcrumbs: {
    label: 'You are in: ',
    searchResultLabel: 'Results for',
    backButtonText: '',
  },
  miniTrolley: {
    increaseBtnLabel: '+',
    decreaseBtnLabel: '-',
  },
  settings: {
    flashMessage: {
      success: 'Changes saved',
      failure: 'Sorry, something went wrong. Please try again.',
    },
    buttons: {
      saveChanges: 'Save changes',
      saved: 'Saved',
      cancel: 'Cancel',
    },
    deliveryPreferences: {
      pageName: 'Delivery Preferences',
      checkboxLabelText: 'Use additional bags to separate raw products.',
      description: {
        __html: `
          <p>
            We're passionate about providing the very best service possible; for our customers, and for the environment.
            We believe shopping with us is the most eco-friendly way to buy groceries, so we aim to use as few plastic bags as possible.
          </p>
          <p>
            Naturally, we're always trying to ensure that products that can damage each other are not packed together.
            Some of our customers told us that they'd rather have their raw meat and fish separated from the rest of their shopping, even if it adds extra plastic bags.
            We've added this as an option; you can turn it on or off below.
          </p>
          <p>
            Please note: if you select this option, it will mean using additional bags to pack the raw products.
            The additional bags may be used to wrap the raw products, or to hold the remaining shopping in the carrier bag.
          </p>
        `,
      },
    },
    marketingCommunication: {
      pageName: 'Marketing Communications',
      description: 'Everyone loves to get exclusive money-off vouchers and special offers. Simply tick these boxes and you\'ll never miss out on a great deal at Ocado.',
      ownOffers: 'Get the best of the Ocado Group delivered by email: goodies, gifts and exclusive offers. You\'ll also have the chance to take part in competitions and occasional marketing research.',
      thirdPartyOffers: 'Receive special offers and information from Ocado on behalf of our carefully selected partners. Don\'t worry, we\'ll never pass your personal details on to other companies for marketing purposes.',
      additionalText: 'Want to know more? Please read our ',
      additionalTextLinkLabel: 'Privacy Policy',
      preferencesURL: '',
      preferencesLabel: '',
      moreInformation: 'For more information, read our',

      marketing: {
        description1: 'Opt in or out of getting offers, vouchers, gifts and other marketing from Ocado about ocado.com and ocadozoom.com, Fetch and our specially selected partners.',
        description2: 'These are the current marketing preferences we hold for you:',
      },

      marketing3rdParty: {
        title: 'From Ocado, about our specially selected partners',
        description: 'From Ocado, about our specially selected partners',
      },
      relatedShops: {
        description: 'From Ocado, about the Ocado Retail Group',
        MAIN: 'From Ocado, about ocado.com and ocadozoom.com',
      },

      MAIL: 'Email',
      SMS: 'SMS',
      PUSH: 'Push notifications',
    },
    marketingCommunicationLI: {
      pageName: 'Marketing Preferences',
      description: 'Everyone loves to get exclusive money-off vouchers and special offers. Simply tick these boxes and you\'ll never miss out on a great deal at Ocado.',
      ownOffers: 'Get the best of the Ocado Group delivered by email: goodies, gifts and exclusive offers. You\'ll also have the chance to take part in competitions and occasional marketing research.',
      thirdPartyOffers: 'Receive special offers and information from Ocado on behalf of our carefully selected partners. Don\'t worry, we\'ll never pass your personal details on to other companies for marketing purposes.',
      additionalText: 'Want to know more? Please read our ',
      additionalTextLinkLabel: 'Privacy Policy',
      preferencesURL: '',
      preferencesLabel: '',
      moreInformation: 'For more information, read our',

      marketing: {
        description1: 'You can select your electronic marketing preferences below. You can change your preferences at any time.',
        description2: '',
      },

      marketing3rdParty: {
        title: '',
        description: `Offers, gifts and other marketing promotions of goods and services about our specially
        selected partners.`,
      },
      relatedShops: {
        description: 'Offers, gifts and other marketing promotions of our goods and services.',
        MAIN: '',
      },

      MAIL: 'Electronic mail',
      SMS: 'SMS',
      PUSH: 'Push Notification',
    },
    cookies: {
      pageName: 'Cookies',
      description: {
        firstSentence: 'A cookie is a small piece of data (text file) that a website – when visited by a user – asks your browser to store on your device in order to remember information about you, such as your language preference or login information. Those cookies are set by us and called first party cookies. We also use third party cookies – which are cookies from a domain different than the domain of the website you are visiting – for our advertising and marketing efforts.',
        secondSentence: 'You can opt-out of each cookie category (except strictly necessary cookies) by clicking on the “cookie settings” button below:',
      },
      settingsBtnName: 'Cookie Settings',
    },
    calendarEvents: {
      pageName: 'Calendar Reminders',
      description: 'Enable attachments and we\'ll send an iCalendar file with your confirmation email to help you keep track of Ocado deliveries in Apple iCal, Windows Calendar, Google Calendar, and more. ',
      checkboxLabelText: 'Enable attachments',
    },
    calorieSaver: {
      pageName: 'Calorie Saver',
      description: 'Calorie Saver suggests lower-calorie alternatives for some products in your trolley. Swap any products you like, and Calorie Saver will count the savings for you.',
      checkboxLabelText: 'Don\'t show Calorie Saver as I check out.',
    },
    foodProfile: {
      pageName: 'Food Profile',
      description: 'Toggle the ingredients you’re allergic and/or intolerant to on. So you’re aware: this service doesn’t work with alcohol; pet and baby food; medication and supplements just yet, so please take care to check the ingredients on those products.',
    },
    loyalty: {
      pageName: '',
      url: '',
    },
    smsAlerts: {
      pageName: 'Delivery SMS Reminders',
      ordersReservedCustomer: '* As an Ocado Reserved customer, to make sure you never miss a delivery, we need to be able to send you SMS Reminders.',
      noNumber: 'You haven\'t added a mobile number yet; you can do this in ',
      removeNumberWarning1: 'By choosing a different phone number here the previous one',
      removeNumberWarning2: 'will be removed. You can then set it up again in ',
      faqLink: 'https://help.ocado.com/hc/en-us/categories/360000708132-Frequently-Asked-Questions',
    },
    accountSettings: {
      pageName: 'Account Settings',
    },
    importYourFavourites: {
      pageName: 'Import Your Favourites',
    },
    deliveryAddressBook: {
      pageName: 'Delivery Addresses',
      description: 'Saved delivery address(es).',
      addNewAddress: 'Add New Address',
      editAddress: 'Edit Instructions',
      errorMessages: {
        addressInUseForOrdersReserved: 'You have this address saved for your Ocado Reserved deliveries.',
        addressWithBookedDeliverySlot: 'You have an outstanding order for delivery at this address.',
        addressWithPendingOrder: 'You have an outstanding order for delivery at this address.',
        notInDeliveryArea: 'The postcode is out of delivery area.',
        unknownError: 'Sorry, something went wrong. Please try again.',
      },
      postcodeInfoMessage: '',
      addressBookValidationMessages: {
        ospZone: 'Can’t find your postcode? We’re in the process of moving over to our new website and app, so you may be in the wrong place. Head to our <a href="https://www.ocado.com/content/osp-delivery-error-faq-252406">postcode information page</a> to find out more.',
        outOfZone: 'Sorry, we don’t deliver to your area at the moment. Head to our <a href="https://www.ocado.com/content/contact-us-175896">Contact us</a> page if you’d like to speak to one of our friendly advisors.',
        unknownError: 'That postcode doesn\'t seem quite right. Double check and enter it again.',
      },
    },
    contactDetails: {
      pageName: 'Account Details',
      slotSubscriptionError: 'Please enter a mobile number so we can send you reminders about Ocado Reserved orders.',
    },
    storedPaymentDetails: {
      pageName: 'Payment Details',
      subscriptions: 'Subscriptions',
      activeInstruments: 'Active payment methods',
      inactiveInstruments: 'Inactive payment methods',
      selectPaymentToken: 'Select',
      confirmPaymentToken: 'Confirm',
      no_selected_payment: 'Not selected',
      notChosenPaymentMethod: 'Please choose a payment method',
      description: 'Securely check, update or delete payment details you have stored with us.',
      types: {
        ORDER: 'Orders',
        SLOT_SUB: 'Ocado Reserved',
        OOD: 'Smart Pass',
        NIU: 'Not in use',
      },
      addNewPayment: 'Add Payment Type',
      noPaymentInstruments: 'You don\'t have any payment instruments assigned to your account.',
      noSubscriptions: 'You don\'t have any subscriptions assigned to your account.',
      expirationMsg: 'Some of your cards have expired. Please replace them with a new payment method or delete them.',
      limitExceeded: 'You\'ve reached the maximum number of payment methods. To add a new one, you will need to delete an existing one.',
    },
    facebook: {
      pageName: 'Facebook Login',
      description: {
        linked1: 'Your Ocado account is linked to Facebook, so you can use Facebook to log in to Ocado.',
        linked2: 'Your Ocado account is linked to this Facebook account:',
        unlinked1: 'Link your Facebook account to your Ocado account and use Facebook to log in to Ocado.',
        unlinked2: 'Your Facebook account is not currently linked to your Ocado account.',
      },
      accountAlreadyLinked: {
        title: 'Account already linked',
        description: 'That Facebook account is linked to another Ocado account. Do you want to link a different Facebook account?',
        confirmButtonLabel: 'Yes',
        cancelButtonLabel: 'Cancel',
      },
      loginNotPossiblePopup: {
        title: 'Create Ocado account password',
        description: 'You\'ll need to create a password for Ocado if you unlink your Facebook account. Otherwise you won\'t be able to log in.',
        confirmButtonLabel: 'Continue',
        cancelButtonLabel: 'Cancel',
      },
    },
    payPalLogin: {
      pageName: 'PayPal Login',
      linked: {
        description: {
          firstSentence: 'Link your PayPal account to log in with PayPal.',
          secondSentence: 'Your Ocado account is currently linked to the Paypal account for',
        },
        buttonText: 'Unlink PayPal account',
        belowButton: {
          mainText: 'You\'ll still be able to pay with PayPal if you unlink your PayPal account. You can manage your payments in ',
        },
      },
      unlinked: {
        description: {
          line1: 'Link your PayPal account to your Ocado account and use PayPal to log in to Ocado.',
          line2: 'Your PayPal account is not currently linked to your Ocado account.',
        },
        buttonText: 'Link PayPal account',
        belowButton: {
          mainText: 'even if you don’t have the accounts linked you can still be able to pay using PayPal. You can change this in ',
        },
      },
      belowButton: {
        introduction: 'Note: ',
        linkText: 'Payment Methods',
      },
      accountAlreadyLinked: {
        title: 'Account already linked',
        description: 'That PayPal account is linked to another Ocado account. Do you want to link a different PayPal account?',
        confirmButtonLabel: 'Yes',
      },
      loginNotPossiblePopup: {
        title: 'Create Ocado account password',
        description: 'You\'ll need to create a password for Ocado if you unlink your PayPal account. Otherwise you won\'t be able to log in.',
        confirmButtonLabel: 'Continue',
      },
    },
    changeCredentials: {
      pageName: 'Login & Password',
      description: 'Change your email address and Ocado password.',
      shopPassword: 'Ocado password',
    },
    changeCredentialsInSso: {
      pageName: 'Login Details',
    },
    superuserCheckout: {
      pageName: 'Checkout',
    },
  },
  subscriptions: {
    displayName: 'Ocado Regulars',
    navigationName: 'Choose your Regulars',
    navigationNameShort: 'Choose your Regulars',
    header: {
      title: 'Subscriptions Header Title',
      description: 'Subscriptions Header Description',
      infoBannerLink: 'Link to Info Banner',
      infoBannerUrl: '/#',
    },
    tab: {
      favourites: 'FAVOURITES',
      subscriptions: 'TROLLEY-STARTERS',
    },
    fop: {
      subscribeButton: 'Choose',
    },
    infobox: {
      firstParagraph: 'Regulars are charged at the price shown on the day they\'re added.',
      secondParagraph: 'So, if it\'s on offer when it\'s added, you\'ll pay the offer price.',
    },
    trolleyInfobox: {
      title: 'Here are your<br /> Ocado Regulars',
      content: 'These products have been automatically added to your trolley at the frequency you have chosen.',
      link: 'Manage your Ocado Regulars',
    },
    trolleySection: {
      text: 'Ocado Regulars',
    },
    reset: {
      title: 'Reset Ocado Regulars?',
    },
    recommendations: {
      description: {
        firstPart: 'With Ocado Regulars you can have products you frequently buy added to your trolley on Mondays, as often (or as little) as you like. Start by choosing from these items you regularly order – you can always ',
        secondPart: ' later.',
      },
    },
  },
  login: {
    password: 'Enter Ocado password',
    new_user: 'New to Ocado?',
  },
  elevated: {
    errors: {
      notLinked: 'Account not linked to Ocado. Try again.',
      alreadyLinked: 'Account already linked to Ocado.',
    },
  },
  registration: {
    afterGdprChanges: {
      agreement: 'Opt out of Ocado\'s offers, vouchers, gifts and other electronic marketing.',
      confirmation: {
        firstPart: 'Full details of how we use your information can be found in our ',
        firstLink: '/webshop/scontent/privacyPolicy',
        firstLinkLabel: 'Privacy & Cookie Policy',
        secondPart: '. By registering you confirm you accept our ',
        secondLink: '/webshop/scontent/termsAndConditions',
        secondLinkLabel: 'Terms & Conditions',
        thirdPart: '.',
      },
    },
    beforeGdprChanges: {
      agreement: 'Get money-off vouchers, exclusive offers and all the latest Ocado info delivered straight to your inbox.',
      confirmation: {
        firstPart: 'By registering, you confirm that you accept our ',
        firstLink: '/webshop/scontent/termsAndConditions',
        firstLinkLabel: 'Terms & Conditions',
        secondPart: ', and ',
        secondLink: '/webshop/scontent/privacyPolicy',
        secondLinkLabel: 'Privacy Policy',
        thirdPart: '.',
      },
    },
    facebook_already_linked: 'That Facebook account is already linked to Ocado',
    paypal_already_linked: 'That PayPal account is already linked to Ocado',
  },
  link_accounts: {
    title: 'Link an Ocado account',
    login: 'Ocado account email address',
    password: 'Ocado password',
  },
  error: {
    invalidData: {
      description: 'Perhaps you typed it in wrong, or we didn\'t understand it.',
      title: 'Oh dear, something got scrambled. Press OK to reload the page.',
      header: 'Sorry, we didn\'t catch that.',
    },
    error: {
      callUs: 'or call our Customer Service team on ',
      callUsNum: '0345 656 1234',
      linkTitle: 'This link takes you to the Ocado homepage',
      tryAgain: 'Go back and try again',
    },
  },
  user: {
    mobileAppBanner: {
      bannerHeading: 'Shop faster with our app default',
      bannerMessage: 'Try One-Click: add to an existing order without checking out again.',
      goToStoreButtonText: 'Use the app',
    },
  },
  headerBar: {
    refinedByLabel: 'Refine by',
  },
  payments: {
    threeDSecureInfo: {
      __html:
        `For added security your card issuer needs to verify your card details with either Verified By Visa or Mastercard Securecode.
        <strong>Their own verification page is displayed below.</strong> You will be able to complete your order with Ocado after this step.`,
    },
  },
  checkout: {
    postOrderPage: {
      bagsMessage: 'As part of our Bag Recycling Bonus, we\'ll give you 10p back for every Ocado bag you handback to your driver. You can get a refund for a maximum of 99 Ocado bags at a time. Just tell your driver how many you have.',
      discountClub: {
        savingsPostfix: 'on offers today.',
        passReminder: 'Don\'t forget to make the most of your Smart Pass every time you shop',
        withMembership: 'with your Smart Pass.',
      },
    },
  },
  suggestedOrder: {
    navigationName: 'Instant Shop',
    availableUserInfo: 'Save time by using our suggested order feature',
    unavailableUserInfo: 'You\'ve not completed your first shop, so you won\'t see anything here yet. Once you\'ve shopped with us, we\'ll be able to create a suggested order, based on the items that you like to buy the most.',
  },
  feedbackPopup: {
    title: 'Let us know what you think',
    sentTitle: 'Thank you for your feedback.',
    changelogHeader: 'We want to make sure our service is the best it can be. Please get in touch using the feedback form to the right if you experience any of the following:',
    changelog: [
      'Trouble finding products.',
      'Problems with the website.',
      'Anything that frustrates or irritates.',
      'Joy and delight at shopping with Ocado, we love to hear positive feedback, too!',
    ],
    formTitle: 'If you have any feedback or you encounter any problems, please let us know:',
    fieldCategoryLabel: 'Choose issue type:',
    fieldCategoryPlaceholder: 'Please choose a category',
    fieldMessageLabel: 'Your message:',
    btnSubmit: 'Send',
  },
  notFound: {
    heading: '',
    requestProductLinkLabel: 'product request',
  },
  reviews: {
    nicknameInfo: 'Your nickname will appear on your ocado.com reviews. You don’t need to use your real name but you can’t change your nickname later.',
    validationErrors: {
      nickname: {
        Length: 'Your nickname should be between 2 and 28 characters in length.',
      },
      rating: {
        Min: 'The rating is too low.',
        Max: 'The rating is too high.',
      },
      reviewTitle: {
        Length: 'The title is too long.',
      },
      reviewText: {
        Length: 'The text is too long.',
      },
    },
  },
  staticContent: {
    faqRedirectionLink: 'http://help.ocado.com',
  },
  mobileNotifications: {
    changeDelivery: {
      id: 'ChangeDelivery',
      type: 'CHANGE_DELIVERY',
      title: 'Booked slot info',
      body: (slotHeldUntilDate) => `Your booked slot will be held until ${slotHeldUntilDate}`,
      label: 'Change',
      deletable: false,
      channels: ['MOBILE_LOGGED_IN_HOMEPAGE'],
    },
    editOrderDelivery: {
      id: 'EditOrderDelivery',
      type: 'EDIT_ORDER_DELIVERY',
      title: 'Edit your order',
      body: (editOrderUntilDate) => `You can edit your order until ${editOrderUntilDate}`,
      label: 'Edit',
      deletable: false,
      channels: ['MOBILE_LOGGED_IN_HOMEPAGE'],
    },
    deliveryPass: {
      type: 'DELIVERY_PASS',
      label: 'Info',
    },
  },
  productsExpirationDate: {
    defaultText: (formattedMinimumShelfLife, averageShelfLife, minimumShelfLife) =>
      `Fresh+ Promise: Product life promised for${averageShelfLife > minimumShelfLife ? ' more than' : ''} ${formattedMinimumShelfLife.toLowerCase()} on top of your delivery day.`,
    minimumShelfLifeIsInDays: (formattedMinimumShelfLife, averageShelfLife, minimumShelfLife) =>
      `Fresh+ Promise: Product life promised for ${formattedMinimumShelfLife.toLowerCase()} on top of your delivery day${averageShelfLife > minimumShelfLife ? `, with an average of ${averageShelfLife} ${averageShelfLife === 1 ? 'day' : 'days'} product life delivered over the last week` : ''}.`,
  },
  yourSavingsHub: {
    welcome: {
      title: 'Hello,',
      messages: {
        welcomeMessage: 'Welcome to your Savings Hub.',
        shoppingSince: 'Shopping since:',
        joined: 'Joined:',
        shopsDelivered: 'Shops delivered:',
      },
    },
    savingMoneySection: {
      couponCard: {
        title: 'Coupons to use.',
        titleNoCoupons: 'Coupons to use. Check back soon.',
        description: 'This is how much you can save with your coupons right now:',
        descriptionNoCoupons: 'How much can you save with coupons? Each year, customers save on average:',
        amountToSaveNoCoupons: '£11.48',
        buttonText: 'View coupons',
        buttonTextNoCoupons: 'Start shopping',

      },
      smartPassCard: {
        title: 'Current membership:',
        titleNoSubscription: 'Start saving with a Smart Pass',
        description: 'This is how much Smart Pass customers like you save on average each year:',
        descriptionNoSubscription: 'How much can you save with Smart Pass? Every year the average Smart Pass customer saves:',
        smartPassSumSavings: '£106',
        buttonText: 'View your Smart Pass',
        buttonTextNoSubscription: 'Sign up to Smart Pass',
      },
      pricePromise: {
        title: 'Your last like-for-like shop came just behind tesco.com in price.',
        description: 'As promised, here’s your ',
        descriptionNoVoucher: 'Over 10,000 products included',
        description2: 'voucher to save on your next shop.',
        description2NoVoucher: 'We match the price of your last like-for-like shop to tesco.com, including Clubcard prices.',
        buttonText: 'Copy code',
        buttonTextNoVoucher: 'How to sign up',

      },

    },

    cardsSavingTimeSection: {
      yshApp: {
        id: 'yshApp',
        header: 'Ocado App',
        savingTimeList: ['Try One-Click for faster shopping.', 'Get in-app receipts.', 'Shop when and wherever you like.'],
        linkAndroidApp: 'https://play.google.com/store/apps/details?hl=en&pli=1&id=com.ocado.mobile.android',
        altAndroidApp: 'Google Play Store',
        linkIOSApp: 'https://apps.apple.com/gb/app/ocado-supermarket-shopping/id319691481',
        altIOSApp: 'Apple App Store',
      },
      reserved: {
        id: 'reserved',
        header: 'Reserved',
        content: "Choose a weekly or fortnightly delivery time and we'll book it automatically with a suggested order that you can edit.",
        buttonText: 'Reserve your slot',
        buttonLink: '/or-signup',
      },
      favourites: {
        id: 'favourites',
        header: 'Favourites',
        content: 'Skip the aisles and go straight to your favourite products.',
        buttonText: 'See your Favourites',
        buttonLink: '/webshop/displayPrevPurchases.do',
      },
      regulars: {
        id: 'regulars',
        header: 'Regulars',
        content: "Order something often? Make it an Ocado Regular and we'll add it to your trolley on Mondays.",
        buttonText: 'Choose your Regulars',
        buttonLink: '/regulars',
      },
      instantShop: {
        id: 'instantShop',
        header: 'Instant shop',
        content: 'We create an order based on your recent Ocado deliveries and you can add some or all of the items to your trolley.',
        buttonText: 'Try instant shop',
        buttonLink: '/webshop/displaySuggestedOrder.do',
      },
      shoppingLists: {
        id: 'shoppingLists',
        header: 'Shopping Lists',
        content: 'Build and save multiple lists to add to your trolley in a flash.',
        buttonText: 'Create a shopping list',
        buttonLink: '/webshop/shoppingLists/display.go',
      },

    },

    FaqAccordionSection: {

      faqs: [
        {
          title: 'What is the Savings Hub?',
          content: 'The Savings Hub page will represent a combination of value propositions that we can offer you. Because now more than ever, we know that you need great value in every shop.',
        },
        {
          title: 'Will the Savings Hub change the way you use my personal information?',
          content: [
            {
              text: 'The Savings Hub won\'t change the way we look after your personal information or shopping data. To learn more about how we keep your information secure,',
              link: {
                href: 'https://ocadoretail.com/wp-content/uploads/2023/03/customer-privacy-notice.pdf',
                text: 'here.',
              },
            },
          ],
        },

        {
          title: 'Does the Savings Hub replace any other initiatives?',
          content: 'Not at all. We\'ve created the Savings Hub to house all our great value benefits and we\'re committed to bringing you this every time you shop.',
        },
        {
          title: 'How can I add offers/coupons from my Savings Hub to my upcoming delivery?',
          content: 'In your Savings Hub, you\'ll see any coupons to use under \'Saving you money\'. You\'ll also find current offers under \'Top Offers\'. To add these to your next delivery, simply hit \'View coupons\' or \'Add to trolley\' and follow your normal checkout journey.',
        },
        {
          title: 'How are my favourites worked out?',
          content: 'After your first shop, we\'ll create a list of favourites for you based on what you like to buy. So, if you tap on the \'Favourites\' tab at the top of the page, you can browse through and shop from a list of groceries you\'ve ordered before.',
        },
      ],

      additionalFaqs: [
        {
          title: 'Help with voucher codes',
          content: {
            title: 'How to use a voucher',
            content: [
              {
                text: 'At check out, you\'ll be prompted to add any voucher codes you may have. Simply enter your code (e.g. VOU1234567) in the text box and hit \'Add\' – you\'ll see a green message to confirm.',
              },
              {
                text: 'Please note: only one voucher code can be added per delivery.',
                link: {
                  href: 'https://www.ocado.com/content/ocado-price-promise-terms-and-conditions-227310?mi_ecmp=orlOPPDailySend&mi_u=34427357&utm_campaign=OPP%20-%20Daily%20send&utm_content=EML_ADHO_SALE_SEAS_Customer_OPP6&utm_medium=email&utm_source=ACS&utm_term=&ad=254081%7C6471078%7C254744%7C6066968',
                  text: 'T&Cs',
                },
              },
              {
                title: 'Why isn\'t my voucher code working?',
                text: 'Why isn\'t my voucher code working? Double-check the details on your voucher to make sure it\'s still valid. All our vouchers will have \'order by\' dates, and some may have particular restrictions depending on what the voucher is for.',
              },
              {
                text: 'Still having trouble? Get in contact with us,',
                link: {
                  href: 'https://www.ocado.com/content/contact-us-175896?ad=254081%7C6471078%7C254744%7C6066968',
                  text: 'here.',
                },
              },
            ],
          },
        },
        {
          title: 'Do you still offer Smart Pass anniversary gifts?',
          content: 'The Smart Pass anniversary gift is a £10 voucher, available to all Smart Pass customers once a year so make sure you keep an eye on your inbox during your anniversary month (the month you joined).',
        },
      ],
    },
    FaqAccordionSectionGeneralInfo: {

      sectionTitle: 'Frequently asked questions',
      footerMoreQuestions: 'Still have some questions?',
      footerButtonTextMoreFaqs: 'Show more FAQs',
      footerHelpCentreLink: 'https://www.ocado.com/content/help-centre-175773?ad=254081%7C6471078%7C254744%7C6066968',
      footerHelpCentreLinkText: 'View our Help Centre',
    },
    ProductCarousel1: {
      title: 'Top Offers',
      description: 'Check out this selection of popular products on offer.',

    },
    ProductCarousel2: {
      title: 'Our amazing new arrivals',
      description: 'Try these new products that have just arrived.',

    },
    ProductCarousel3: {
      title: 'Top trending products',
      description: 'These products are really popular this week. Get them while they’re hot!',

    },
    pricePromiseText: 'Ocado Price Promise',
    buttonLinkPromise: '/content/ocado-price-promise-227302',
    smartPassText: 'Smart Pass',
    buttonLinkSmartPass: '/webshop/displayDeliveryPass.do',
    couponCardText: 'Coupons',
    buttonLinkCardNoCoupons: '/browse',
    buttonLinkCardCoupons: '/webshop/coupons.go?src=menu',

    sectionPrint: {
      couponAveragesTitle: 'Coupon customer averages',
      couponAveragesText: '£11.48 is based on the average yearly savings a customer makes using coupons. Data correct as of 26.04.2024.',
      smartPassAveragesTitle: 'Smart Pass customer averages',
      smartPassAveragesText: '£106 is based on the average yearly saving an Anytime SmartPass customer makes on a weekly delivery. Data taken from 01.05.2023 - 30.04.2024 (inclusive)',
    },
  },

  newShelfLife: {
    toolTip: 'Look out for this icon while you shop. It’ll show you how many days (at least) your product will be at its best after your delivery day.',
  },
  cspUrlList: {
    paymentDetails: '/settings/payment-details',
    oReserved: '/or-register',
    addPaymentType: '/settings/add-payment-type',
  },
};
